import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@/features/public/pages/contact";

type ContactSearch = {
  subject?: string;
};

export const Route = createFileRoute("/(public)/_public/contact")({
  validateSearch: (search: Record<string, unknown>): ContactSearch => ({
    subject: typeof search.subject === "string" ? search.subject : undefined,
  }),
  component: function Contact() {
    const { subject } = Route.useSearch();
    return <ContactPage defaultSubject={subject} />;
  },
});
